import React, { Fragment, useEffect, useContext } from 'react';
import { Col, Card, Table } from 'reactstrap';
import { Edit } from "react-feather"
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { getPage } from '../../store/pagesSlice';
import CustomizerContext from '../../_helper/Customizer';

const PageTable = () => {
  const storeVar = useSelector(state => state.page)
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { layoutURL } = useContext(CustomizerContext);

  useEffect(() => {
    dispatch(getPage())
  }, []);

  const onClickNavigate = (data) => {
    navigate('/edit-page/' + layoutURL + '?id=' + data.type)
  }

  return (
    <Fragment>
      <Col sm='12'>
        <Card>
          <div className='table-responsive'>
            <Table hover={true} className='table-border-horizontal table-light'>
              <thead>
                <tr>
                  <th scope='col'>Sl.No</th>
                  <th scope='col'>Name</th>
                  <th scope='col'>Action</th>
                </tr>
              </thead>
              <tbody>
                {storeVar.pageData?.map((item, index) => (
                  <tr key={item._id}>
                    <th scope='row'>{index + 1}</th>
                    <td>{item.title}</td>
                    <td>
                      <div className='d-flex gap-2'>
                        <div className='cursor-pointer bg-light-primary font-primary action-icon'>
                          <Edit onClick={(e) => onClickNavigate(item)} />
                          <div className="tooltipCustom">Edit</div>
                        </div>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </Card>
      </Col>

    </Fragment>
  );
};

export default PageTable;
